var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-overlay-wrapper"},[_c('div',{staticClass:"error-message-wrapper",style:(_vm.errorMessageWrapperStyle)},[_c('div',{staticClass:"error-message",style:(_vm.errorMessageStyle)},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"error-sub-message"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }